import React, { useState, useMemo } from 'react';
import {
  Input,
  Textarea,
  Button,
  Spacer,
  Text,
  Dropdown,
  Card,
  Row
} from '@nextui-org/react';
import { toast, Toaster } from 'react-hot-toast';

const instructors = [
  { key: "john", name: "John Doe" },
  { key: "jane", name: "Jane Smith" },
  { key: "alice", name: "Alice Johnson" },
];

const CreateWorkshop = () => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [dateTime, setDateTime] = useState('');
  const [instructor, setInstructor] = useState<string>('');
  const [cover, setCover] = useState<File | null>(null);

  const selectedInstructorValue = useMemo(
    () => {
      const selected = instructors.find(i => i.key === instructor);
      return selected ? selected.name : "Select Instructor";
    },
    [instructor]
  );

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const target = e.target as HTMLInputElement;
    if (target.files && target.files[0]) {
      setCover(target.files[0]);
    }
  };

  const validate = () => {
    if (!title) return "Title is required";
    if (!description) return "Description is required";
    if (!dateTime) return "Date and Time is required";
    if (!instructor) return "Instructor is required";
    if (!cover) return "Cover image is required";
    return null;
  };

  const handleSaveDraft = () => {
    toast.success('Draft saved!');
    console.log({ title, description, dateTime, instructor, cover: cover?.name, status: 'draft' });
  };

  const handlePublish = () => {
    const error = validate();
    if (error) {
      toast.error(error);
      return;
    }
    toast.success('Workshop published!');
    console.log({ title, description, dateTime, instructor, cover: cover?.name, status: 'published' });
  };

  return (
    <Card css={{ mw: "600px", p: "$10", margin: "auto", mt: "$10" }}>
      <Toaster />
      <Text h2>Create New Workshop</Text>
      <Spacer y={1.5} />

      <Input
        label="Workshop Title"
        placeholder="Enter workshop title"
        fullWidth
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />
      <Spacer y={1.5} />

      <Textarea
        label="Description"
        placeholder="Enter workshop description"
        fullWidth
        minRows={4}
        value={description}
        onChange={(e) => setDescription(e.target.value)}
      />
      <Spacer y={1.5} />

      <Input
        label="Date and Time"
        type="datetime-local"
        fullWidth
        value={dateTime}
        onChange={(e) => setDateTime(e.target.value)}
      />
      <Spacer y={1.5} />

      <Text size="$md" css={{ mb: '$2', display: 'block' }}>Instructor</Text>
      <Dropdown>
        <Dropdown.Button flat css={{ tt: "capitalize", width: "100%" }}>
          {selectedInstructorValue}
        </Dropdown.Button>
        <Dropdown.Menu
          aria-label="Instructor selection"
          disallowEmptySelection
          selectionMode="single"
          selectedKeys={new Set([instructor])}
          onSelectionChange={(keys) => {
              // keys is a Set
              const selected = Array.from(keys)[0] as string;
              setInstructor(selected);
          }}
        >
          {instructors.map((item) => (
              <Dropdown.Item key={item.key}>{item.name}</Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
      <Spacer y={1.5} />

      <Text size="$md" css={{ mb: '$2', display: 'block' }}>Event Cover</Text>
      <Input
        type="file"
        fullWidth
        accept="image/*"
        onChange={(e) => handleFileChange(e as unknown as React.ChangeEvent<HTMLInputElement>)}
      />
      <Spacer y={2} />

      <Row justify="space-between">
        <Button light color="secondary" onClick={handleSaveDraft}>
          Save Draft
        </Button>
        <Button onClick={handlePublish}>
          Publish
        </Button>
      </Row>
    </Card>
  );
};

export default CreateWorkshop;
